import {
    HTTP_INTERCEPTORS,
    HttpClient,
    provideHttpClient,
    withFetch,
    withInterceptorsFromDi,
} from '@angular/common/http';
import {
    ApplicationConfig,
    ErrorHandler,
    Injectable,
    importProvidersFrom,
    inject,
    provideAppInitializer,
} from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { Router, provideRouter } from '@angular/router';
import { iosTransitionAnimation } from '@ionic/angular';
// TODO(ionic-10): '@ionic/angular/lazy' and IonicModule are deprecated in Ionic 9
// (see node_modules/@ionic/angular/README.md) and will be removed in a future
// major. Migrate to standalone Ion* component imports + provideIonicAngular().
import { IonicModule } from '@ionic/angular/lazy';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { LoggerModule, NgxLoggerLevel } from 'ngx-logger';
import { AppInitService } from '../config/app-init.service';
import { ngxTranslateConfig } from '../config/ngx-translate.config';
import { appRoutes } from './app.routes';
import { HttpConfigInterceptor } from './interceptors/httpconfig.interceptor';

import { BrowserModule, HAMMER_GESTURE_CONFIG, HammerGestureConfig, HammerModule } from '@angular/platform-browser';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TraceService, createErrorHandler } from '@sentry/angular';
import * as Hammer from 'hammerjs';
import { Chart } from 'chart.js';
import Annotation from 'chartjs-plugin-annotation';
import ChartDataLabels from 'chartjs-plugin-datalabels';

// Register Chart.js plugins globally
Chart.register(Annotation);
Chart.register(ChartDataLabels);

const appInitializerFn = (appInitService: AppInitService) => appInitService.init();

@Injectable()
export class MyHammerConfig extends HammerGestureConfig {
    override overrides = {
        swipe: { direction: Hammer.DIRECTION_HORIZONTAL },
    };
}

export const appConfig: ApplicationConfig = {
    providers: [
        AppInitService,
        provideRouter(appRoutes),
        provideAnimations(),
        importProvidersFrom(
            IonicModule.forRoot({
                // navAnimation: slideInOutAnimation,
                // navAnimation: iosCustomTransitionAnimation,
                navAnimation: iosTransitionAnimation,
            }),
            HammerModule,
            // LoggerModule.forRoot({ level: environment.production ? NgxLoggerLevel.INFO : NgxLoggerLevel.DEBUG }),
            LoggerModule.forRoot({ level: NgxLoggerLevel.DEBUG }),
            TranslateModule.forRoot(ngxTranslateConfig),
        ),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpConfigInterceptor,
            multi: true,
        },
        provideHttpClient(withInterceptorsFromDi()),
        {
            provide: HAMMER_GESTURE_CONFIG,
            useClass: MyHammerConfig,
        },
        provideAppInitializer(() => appInitializerFn(inject(AppInitService))),
        {
            provide: ErrorHandler,
            useValue: createErrorHandler(),
        },
        {
            provide: TraceService,
            deps: [Router],
        },
    ],
};
